/**
 * @generated SignedSource<<123290c631fa610796d5c87fe290722e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TagUpdateTitleInput = {
  id: string;
  title: string;
};
export type TagUpdateColorInput = {
  color: string;
  id: string;
};
export type TodoCategoryTagEditScreenMutation$variables = {
  categoryId: string;
  updateColorInput: TagUpdateColorInput;
  updateTitleInput: TagUpdateTitleInput;
};
export type TodoCategoryTagEditScreenMutation$data = {
  readonly todoCategory: {
    readonly tagUpdateColor: {
      readonly todoCategory: {
        readonly id: string;
        readonly tags: ReadonlyArray<{
          readonly color: string;
          readonly id: string;
          readonly title: string;
        }>;
      };
    };
    readonly tagUpdateTitle: {
      readonly todoCategory: {
        readonly id: string;
      };
    };
  } | null;
};
export type TodoCategoryTagEditScreenMutation = {
  response: TodoCategoryTagEditScreenMutation$data;
  variables: TodoCategoryTagEditScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "updateColorInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "updateTitleInput"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "categoryId"
      }
    ],
    "concreteType": "TodoCategoryMutation",
    "kind": "LinkedField",
    "name": "todoCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "updateTitleInput"
          }
        ],
        "concreteType": "TagUpdateTitlePayload",
        "kind": "LinkedField",
        "name": "tagUpdateTitle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategory",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "updateColorInput"
          }
        ],
        "concreteType": "TagUpdateColorPayload",
        "kind": "LinkedField",
        "name": "tagUpdateColor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategory",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryTagEditScreenMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TodoCategoryTagEditScreenMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "02f47f26b40b23b69b9349b90cb9abb4",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryTagEditScreenMutation",
    "operationKind": "mutation",
    "text": "mutation TodoCategoryTagEditScreenMutation(\n  $categoryId: ID!\n  $updateTitleInput: TagUpdateTitleInput!\n  $updateColorInput: TagUpdateColorInput!\n) {\n  todoCategory(id: $categoryId) {\n    tagUpdateTitle(input: $updateTitleInput) {\n      todoCategory {\n        id\n      }\n    }\n    tagUpdateColor(input: $updateColorInput) {\n      todoCategory {\n        id\n        tags {\n          id\n          color\n          title\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b1155b601fd21f8abbab7448b614faf";

export default node;
